module.exports = __webpack_public_path__ + "images/TrelloGoldBadge.875c4ec765b7ae5701fb.png";